import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { useProfile } from '../hooks/usePortfolioData';

const Footer = () => {
  const { profile } = useProfile();

  const name = profile?.name || 'Portfolio';
  const title = profile?.title || '';
  const subtitle = profile?.subtitle || '';
  const nationality = profile?.nationality || '';
  const email = profile?.contact?.email || '';
  const phones = profile?.contact?.phones || [];

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{name}</h3>
            <p className="text-gray-300 mb-2">{title}</p>
            <p className="text-gray-300 mb-4">{subtitle}</p>
            <p className="text-sm text-gray-400">{nationality}</p>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="font-medium mb-4">Contact</h4>
            <div className="space-y-2">
              {email && (
                <div className="flex items-center space-x-2 text-sm text-gray-300">
                  <Mail size={16} />
                  <a href={`mailto:${email}`} className="hover:text-white transition-colors">
                    {email}
                  </a>
                </div>
              )}
              {phones.map((phone, index) => (
                <div key={index} className="flex items-center space-x-2 text-sm text-gray-300">
                  <Phone size={16} />
                  <a href={`tel:${phone}`} className="hover:text-white transition-colors">
                    {phone}
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Mission Statement */}
          <div>
            <h4 className="font-medium mb-4">Mission</h4>
            <p className="text-sm text-gray-300 leading-relaxed">
              Delivering projects that combine design excellence with technical integrity,
              meeting international standards while serving unique client needs.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex items-center justify-center gap-4">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} {name}. Professional Architecture Portfolio.
            </p>
          </div>

          {/* Powered by Parsec */}
          <div className="flex items-center justify-center gap-3 mt-6 pt-4 border-t border-gray-800">
            <span className="text-xs text-gray-500">Powered by</span>
            <a
              href="https://parsec.solutions"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-60 hover:opacity-100 transition-opacity"
            >
              <img
                src="/images/parsec-logo.png"
                alt="Parsec Solutions"
                className="h-6"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
